import React, { useState } from "react";
import ReportBillSummary from "./ReportBillSummary";
import ReportBillPayment from "./ReportBillPayment";
import ReportDue from "./ReportDue";

const Report = () => {
  const [activeReport, setActiveReport] = useState("BillSummary"); // Default set to Summary

  // Function to render the currently active report component
  const renderActiveReport = () => {
    switch (activeReport) {
      case "BillSummary":
        return <ReportBillSummary />;
      case "BillPayment":
        return <ReportBillPayment />;
      case "Due":
        return <ReportDue />;
      default:
        return (
          <div className="empty-state">
            <i className="bi bi-bar-chart-steps"></i>
            <p>Select a report type to view details.</p>
          </div>
        );
    }
  };

  return (
    <div className="report-container">
      <div className="report-card">
        
        {/* Header */}
        <div className="report-header">
          <div className="header-left">
            <div className="header-icon">
              <i className="bi bi-file-earmark-bar-graph"></i>
            </div>
            <div className="header-text">
              <h5>Financial Reports</h5>
              <p>View billing summaries, payment history, and due reports</p>
            </div>
          </div>
        </div>

        <div className="card-content">
          {/* Navigation Tabs */}
          <div className="report-tabs">
            <button
              type="button"
              className={`tab-btn ${activeReport === "BillSummary" ? "active" : ""}`}
              onClick={() => setActiveReport("BillSummary")}
            >
              <i className="bi bi-receipt"></i> Bill Summary
            </button>

            <button
              type="button"
              className={`tab-btn ${activeReport === "BillPayment" ? "active" : ""}`}
              onClick={() => setActiveReport("BillPayment")}
            >
              <i className="bi bi-credit-card"></i> Bill Payment
            </button>

            <button
              type="button"
              className={`tab-btn ${activeReport === "Due" ? "active" : ""}`}
              onClick={() => setActiveReport("Due")}
            >
              <i className="bi bi-exclamation-circle"></i> Due Report
            </button>
          </div>

          {/* Report Content Area */}
          <div className="report-view-area">
            {renderActiveReport()}
          </div>
        </div>
      </div>

      {/* ✅✅✅ DYNAMIC CSS (UPDATED TO COMPACT) ✅✅✅ */}
      <style jsx>{`
        *, *::before, *::after { box-sizing: border-box; }
        .report-container { padding: 0; font-family: system-ui, sans-serif; }

        .report-card {
          background: white; border-radius: 6px;
          box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
          border: 1px solid #e0e6ed; overflow: hidden;
        }

        /* Header */
        .report-header {
          background: var(--theme-color, #0088cc);
          padding: 6px 12px; border-bottom: 2px solid rgba(0,0,0,0.1);
          border-radius: 6px 6px 0 0; display: flex; align-items: center;
        }

        .header-left { display: flex; align-items: center; gap: 8px; color: white; }

        .header-icon {
          width: 26px; height: 26px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 4px; display: flex; align-items: center; justify-content: center;
          font-size: 14px; color: white;
        }

        .header-text { display: flex; align-items: baseline; gap: 8px; }
        .header-text h5 { margin: 0; color: white; font-size: 13px; font-weight: 600; line-height: 1.2; }
        .header-text p { margin: 0; color: rgba(255, 255, 255, 0.85); font-size: 10px; }

        .card-content { padding: 10px 12px; }

        /* Tabs Navigation */
        .report-tabs {
          display: flex; gap: 6px; margin-bottom: 10px;
          border-bottom: 1px solid #e0e6ed; padding-bottom: 8px;
          flex-wrap: wrap;
        }

        .tab-btn {
          flex: 1;
          height: 26px; /* COMPACT HEIGHT */
          display: flex; align-items: center; justify-content: center; gap: 6px;
          padding: 0 12px; border-radius: 4px; border: 1px solid #cbd5e0;
          background: #f8f9fa; color: #2c3e50;
          font-size: 11px; /* COMPACT FONT */
          font-weight: 600; cursor: pointer;
          transition: all 0.2s ease; min-width: 120px;
        }

        .tab-btn:hover {
          background: #e0f2fe; color: var(--theme-color, #0088cc);
          border-color: var(--theme-color, #0088cc);
        }

        /* Active Tab Styling */
        .tab-btn.active {
          background: var(--theme-color, #0088cc);
          color: white; border-color: var(--theme-color, #0088cc);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .tab-btn i { font-size: 12px; }

        /* Report View Area */
        .report-view-area {
          background: #fff;
          min-height: 200px;
          animation: fadeIn 0.2s ease-in-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(2px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Empty State */
        .empty-state {
          text-align: center; padding: 30px 20px; color: #94a3b8;
          border: 1px dashed #cbd5e0; border-radius: 4px;
          background: #f8fafc;
        }
        .empty-state i { font-size: 24px; margin-bottom: 6px; display: block; opacity: 0.5; }
        .empty-state p { font-size: 11px; margin: 0; }

        @media (max-width: 768px) {
          .report-tabs { flex-direction: column; gap: 4px; }
          .tab-btn { width: 100%; justify-content: flex-start; }
        }
      `}</style>
    </div>
  );
};

export default Report;